import { checkDeviceResolution } from '../utils/check-device-resolution';
import { productStickyImages } from './product-fixed-image';

$(document).on('touchstart', '.js-accordion-footer-title', function (event) {
  const $this = $(this);
  const $wrapper = $this.closest('.js-accordion-footer-wrapper');
  const $body = $wrapper.find('.js-accordion-footer-body');

  if (checkDeviceResolution.isMobile) {
    $this.toggleClass('is-expanded');
    $body
      .stop()
      .slideToggle()
      .closest('.grid__item')
      .siblings()
      .find('.js-accordion-footer-title')
      .removeClass('is-expanded')
      .closest('.js-accordion-footer-wrapper')
      .find('.js-accordion-footer-body')
      .slideUp();
  }
});

// Liquid Accordion
const $accordion = $('.js-accordion');

$accordion.on('click', '.accordion__head', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $accordionBody = $this.next();
  const toggleIsActive = $this.closest('.js-accordion').hasClass('js-accordion-toggle');
  const $accordion = $this.closest('.js-accordion');
  const index = $this.closest('.accordion__section').index();

  let $copiedBody = $accordionBody.clone().css({ visibility: 'hidden', display: 'block', position: 'absolute' });

  $accordion.append($copiedBody);

  const scroller_height = $copiedBody.outerHeight();
  $copiedBody.remove();

  // console.log(scroller_height);

  if (toggleIsActive) {
    $accordionBody
      .stop()
      .slideToggle(400)
      .parent()
      .toggleClass('is-expanded')
      .siblings()
      .removeClass('is-expanded')
      .find('.js-accordion-body')
      .slideUp(400);
  }

  if (!toggleIsActive) {
    $this.parent().toggleClass('is-expanded').siblings().removeClass('is-expanded');
  }

  setTimeout(() => {
    $(window).trigger('scroll');
  }, 500);
});
